<template>
    <div class="sub-page">
        <el-breadcrumb separator="/">
            <i class="el-icon-location"></i>
            <el-breadcrumb-item :to="{ path: '/index/project' }">项目管理</el-breadcrumb-item>
            <el-breadcrumb-item>项目详情</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="content-box pro-detail__wraper" style="padding-bottom: 40px;">
            <el-tabs v-model="curPanel" @tab-click="changeTab">
                <el-tab-pane label="项目详情" name="project">
                    <div class="pro-status-area">
                        <div class="status__bar">
                            <div class="current-status">
                                <span class="label">当前状态：</span><span class="value text-primary">{{statusList[info.status]}}</span>
                            </div>
                            <div class="pro-handlers">
                                <el-button type="primary" @click="goPage('/index/project/check/step1?id='+info.id)" style="margin-right: 10px;" v-if="info.is_batch">批量确认成果</el-button>
                                <el-button v-if="info.status === 0" @click="goPage('/index/project/pay?id='+info.id)" type="primary" style="margin-right: 10px;">付款</el-button>
                                <el-button v-if="info.status < 3 && info.close === 1" @click="closePro(info.id)" type="default">关闭项目</el-button>
                                <el-button v-if="info.status >= 3 && info.status <= 6" @click="goPage(`/index/project/projectrecord?id=${info.id}`)" type="default">记录项目成果</el-button>
                            </div>
                        </div>
                        <el-steps style="margin: 10px 0;" :active="info.status" align-center finish-status="success">
                            <el-step title="发布项目" description=""></el-step>
                            <el-step title="匹配服务人员" description=""></el-step>
                            <el-step title="服务进行中" description=""></el-step>
                            <el-step title="成果确认" description=""></el-step>
                            <el-step title="项目结算" description=""></el-step>
                        </el-steps>
                    </div>
                    <div class="info-area">
                        <div class="area-title">项目概要</div>
                        <div class="order-info">
                            <div class="box">
                                <div class="cell-group">
                                    <div class="cell">
                                        <div class="cell-title">项目名称</div>
                                        <div class="cell-value">{{info.name}}</div>
                                    </div>
                                </div>
                                <div class="cell-group">
                                    <div class="cell">
                                        <div class="cell-title">创建时间</div>
                                        <div class="cell-value">{{info.create_time}}</div>
                                    </div>
                                </div>
                                <div class="cell-group">
                                    <div class="cell">
                                        <div class="cell-title">项目状态</div>
                                        <div class="cell-value">{{statusList[info.status]}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="box">
                                <div class="cell-group">
                                    <div class="cell">
                                        <div class="cell-title">项目编号</div>
                                        <div class="cell-value">{{info.no}}</div>
                                    </div>
                                </div>
                                <div class="cell-group">
                                    <div class="cell">
                                        <div class="cell-title">预计完成时间</div>
                                        <div class="cell-value">{{info.complete_time}}</div>
                                    </div>
                                </div>
                                <div class="cell-group">
                                    <div class="cell">
                                        <div class="cell-title">&nbsp;</div>
                                        <div class="cell-value">&nbsp;</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="record-area">
                            <div class="area-title flex">
                                <div class="area-text">
                                    项目需求
                                </div>
                                <div class="area-title__handle" v-if="info.status > 0 && info.status !== 7">
                                    <el-button size="small" style="margin-right: 5px;" @click="downloadQD">下载清单</el-button>
                                    <el-button size="small" @click="downloadFBD">下载发布单</el-button>
                                </div>
                            </div>
                            <div class="table striped--header" style="padding-left: 0">
                                <el-table
                                    :data="info.service"
                                    :border="true"
                                    :stripe="true"
                                >
                                    <el-table-column
                                        prop="name"
                                        align="center"
                                        :show-overflow-tooltip="true"
                                        width="600"
                                        label="服务内容">
                                    </el-table-column>
                                    <el-table-column
                                        prop="unit"
                                        align="center"
                                        label="单位">
                                    </el-table-column>
                                    <el-table-column
                                        prop="amount"
                                        align="center"
                                        label="预估人数">
                                    </el-table-column>
                                    <el-table-column
                                        label="预估单价"
                                        align="center"
                                        prop="price">
                                    </el-table-column>
                                    <el-table-column
                                        label="预估总价"
                                        align="center"
                                        width="140"
                                        prop="money">
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                        <div class="record-area" v-if="info.work_status === 1">
                            <div class="area-title flex fix">
                                <div class="area-text">
                                    成果概览
                                </div>
                            </div>
                            <div class="table striped--header" style="padding-left: 0">
                                <el-table
                                    :data="[info.work_statistics]"
                                    :border="true"
                                    :stripe="true"
                                >
                                    <el-table-column
                                        prop="num"
                                        align="center"
                                        label="服务数">
                                    </el-table-column>
                                    <el-table-column
                                        align="center"
                                        label="未提交成果">
                                        <template>
                                            <el-button v-if="info.work_statistics.not_submit > 0" class="text-underline" type="text" @click="filterByFakeStatus(0)" size="medium">{{info.work_statistics.not_submit}}</el-button>
                                            <span v-else>{{info.work_statistics.not_submit}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        align="center"
                                        label="待审核">
                                        <template>
                                            <el-button v-if="info.work_statistics.to_verify > 0" class="text-underline" type="text" @click="goPage(`/index/project/serviceresults?project_name=${info.name}&status=1`)" size="medium">{{info.work_statistics.to_verify}}</el-button>
                                            <span v-else>{{info.work_statistics.to_verify}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        align="center"
                                        label="驳回成果">
                                        <template>
                                            <el-button v-if="info.work_statistics.reject > 0" class="text-underline" type="text" @click="goPage(`/index/project/serviceresults?project_name=${info.name}&status=3`)" size="medium">{{info.work_statistics.reject}}</el-button>
                                            <span v-else>{{info.work_statistics.reject}}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        align="center"
                                        label="审核通过">
                                        <template>
                                            <el-button v-if="info.work_statistics.success > 0" class="text-underline" type="text" @click="goPage(`/index/project/serviceresults?project_name=${info.name}&status=2`)" size="medium">{{info.work_statistics.success}}</el-button>
                                            <span v-else>{{info.work_statistics.success}}</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </div>
                    <div class="content-box__inner" v-if="info.work.length > 0">
                        <div class="area-title">成果记录</div>
                        <div class="service-work__wrapper" style="margin-top: 12px;">
                            <div class="service-work" v-for="(sw, idx) in info.work" :key="idx">
                                <div class="abstract">
                                    <div class="committer">提交人：{{sw.from}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;【 {{recordType[sw.type]}} 】</div>
                                    <div class="time">{{sw.create_time}}</div>
                                </div>
                                <div class="content-wrapper">
                                    <div class="main">
                                        <div class="content">
                                            {{sw.content}}
                                        </div>
                                        <div class="pics">
                                            <div class="pic-item" v-for="(pic, ids) in sw.pics" :key="'sw' + ids">
                                                <span class="download-btn"  @click="fileDownload(pic.src, pic.filename)">{{pic.filename || '成果'}}</span>
                                                <span class="preview-btn" @click="toPreview(pic.src)">预览</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="oprate-area">
                                        <el-button v-if="info.status >= 3 && info.status <= 6" type="error" size="small" @click="deleteServiceWork(sw.id)">删除</el-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </el-tab-pane>
                <el-tab-pane label="服务列表" name="service" v-if="![0,7].includes(info.status)">
                    <div class="search-box">
                        <el-form :inline="true" :model="formFilter" class="demo-form-inline">
                            <el-form-item label="姓名">
                                <el-input v-model="formFilter.name" placeholder="请输入姓名"></el-input>
                            </el-form-item>
                            <el-form-item label="身份证号">
                                <el-input v-model="formFilter.idcard" placeholder="请输入身份证号"></el-input>
                            </el-form-item>
                            <el-form-item label="服务状态">
                                <el-select v-model="formFilter.status" placeholder="请选择服务状态">
                                    <el-option label="全选" value=""></el-option>
                                    <el-option :label="item" :value="key" v-for="(item, key) in subStatusList" :key="key"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item v-if="info.work_status === 1" label="成果状态">
                                <el-select v-model="formFilter.fake_status" placeholder="请选择成果状态">
                                    <el-option label="全选" value=""></el-option>
                                    <el-option :label="item" :value="key" v-for="(item, key) in resStatusList" :key="key"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="onFilter">查询</el-button>
                            </el-form-item>
                            <el-form-item>
                                <el-button v-if="isExportShow" @click="onExport">导出</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="content-box" style="min-height: unset;margin: 0 -20px 0 -20px;">
                        <div class="table" style="padding: 0;">
                            <el-table
                                ref="serviceTable"
                                @selection-change="selectionChange"
                                :data="subproject"
                                :stripe="true"
                                :border="true"
                                :row-key="getRowKeys"
                                :expand-row-keys="expands"
                                @row-click="toggleRowExpansion"
                            >
                                <el-table-column
                                    type="selection"
                                    align="center"
                                    :selectable='checkboxInit'
                                    width="55">
                                </el-table-column>
                                <el-table-column
                                    prop="no"
                                    align="center"
                                    :show-overflow-tooltip="true"
                                    label="服务编号">
                                </el-table-column>
                                <el-table-column
                                    prop="name"
                                    align="center"
                                    label="姓名">
                                    <template slot-scope="scope">
                                        <el-button type="text" @click.stop="goPage(`/index/member/personal?id=${scope.row.member_id}`)" size="medium">{{scope.row.name}}
                                        </el-button>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="idcard"
                                    align="center"
                                    :show-overflow-tooltip="true"
                                    label="身份证号">
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    label="服务数量">
                                    <template slot-scope="scope">
                                        <span>{{scope.row.item}}项</span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="money"
                                    align="center"
                                    label="服务总额">
                                </el-table-column>
                                <el-table-column
                                    prop="complete_time"
                                    align="center"
                                    :show-overflow-tooltip="true"
                                    label="预计完成时间">
                                </el-table-column>
                                <el-table-column
                                    label="服务状态"
                                    :show-overflow-tooltip="true"
                                    align="center">
                                    <template slot-scope="scope">
                                        {{subStatusList[scope.row.status]}}
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    v-if="info.work_status === 1"
                                    label="成果状态"
                                    :show-overflow-tooltip="true"
                                    align="center">
                                    <template slot-scope="scope">
                                        {{resStatusList[scope.row.fake_status]}}
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="操作"
                                    align="center"
                                    width="150">
                                    <template slot-scope="scope">
                                        <el-button type="text" @click.stop="toDetail(scope.row.sub_id)" size="medium">详情
                                        </el-button>
                                        <el-button type="text" v-if="scope.row.status === 0"
                                                   @click.stop="changeServiceStatus(scope.row.sub_id, 1)" size="medium">确认
                                        </el-button>
                                        <el-button type="text" v-if="scope.row.status === 1"
                                                   @click.stop="messageNotify(scope.row.sub_id, 6)" size="medium">短信提醒
                                        </el-button>
                                        <el-button type="text" v-if="scope.row.status === 2"
                                                   @click.stop="goPage(`/index/project/queryresult?id=${$route.query.id}&sub_id=${scope.row.sub_id}`)"
                                                   size="medium">确认成果
                                        </el-button>
                                        <el-button type="text"
                                                   v-if="scope.row.status === 5 || scope.row.status === 7"
                                                   @click.stop="goPage(`/index/project/queryresult?id=${$route.query.id}&sub_id=${scope.row.sub_id}`)"
                                                   size="medium">确认成果
                                        </el-button>
                                        <el-button type="text" v-if="scope.row.status === 8"
                                                   @click.stop="messageNotify(scope.row.sub_id, 8)" size="medium">短信提醒
                                        </el-button>
                                        <el-button type="text" v-if="scope.row.status === 9"
                                                   @click.stop="goPage(`/index/project/querysettle?id=${$route.query.id}&sub_id=${scope.row.sub_id}`)"
                                                   size="medium">确认结算
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="table-extra">
                                <div class="operation">
                                    <el-checkbox @change="serviceTableSelectChange" v-model="isCheckAll" :indeterminate="isIndeterminate"></el-checkbox>
                                    <el-button type="default" @click="batchConfirm" size="medium" style="margin-left: 10px;">批量确认人员</el-button>
<!--                                    <el-button type="default" @click="batchSettlement" size="medium">批量确认结算</el-button>-->
                                </div>
                                <div class="pagination" v-if="total_page > 1">
                                    <el-pagination
                                        background
                                        layout="prev, pager, next"
                                        :page-size="10"
                                        @current-change="onPageChange"
                                        :page-count="total_page">
                                    </el-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <el-dialog
            :visible.sync="photoViewer.status"
            :footer-hide="true"
            title="图片浏览"
            :show-close="false"
            class="photo-viewer"
        >
            <img :src="photoViewer.path"
                 style="display: block; max-width: 488px; max-height: 706px;"
            >
        </el-dialog>
    </div>
</template>

<script>
import qs from 'qs'
import router from '@/router'
import URL from 'url'
import merge from 'webpack-merge'
import { mapState } from 'vuex'

export default {
    name: 'Detail',
    inject: ['goPage'],
    data () {
        const resStatusList = ['未提交', '待审核', '已通过', '未通过']
        const subStatusList = ['待企业确认用户服务', '待用户确认服务', '服务进行中', '待支付服务成果', '待平台审核服务成果', '审核失败，待重新确认', '服务成果待用户确认', '用户异议，待重新确认', '待用户申请结算', '待确认服务结算', '打款中', '打款失败，请联系客服', '重新发起打款', '已完成', '已关闭', '用户拒绝,已关闭']
        return {
            resStatusList,
            recordType: ['服务者记录', '发包商户记录', '项目经理记录'],
            subStatusList,
            statusList: ['待支付', '待匹配', '服务待确认', '服务进行中', '成果待确认', '服务待结算', '已完成', '已关闭'],
            photoViewer: {
                status: false,
                path: ''
            },
            formFilter: {
                name: '',
                idcard: '',
                status: '',
                fake_status: ''
            },
            form: {
                name: '',
                idcard: '',
                status: '',
                fake_status: ''
            },
            subproject: [],
            service: [],
            info: {
                work: [],
                work_statistics: {}
            },
            total_page: 0,
            getRowKeys (row) {
                return row.sub_id
            },
            expands: [],
            isIndeterminate: false,
            isCheckAll: false,
            curPanel: 'project'
        }
    },
    beforeRouteEnter (to, from, next) {
        let curPanel = (to.query.panel * 1 === 1) ? 'service' : 'project'
        next(vm => {
            vm.curPanel = curPanel
        })
    },
    beforeRouteUpdate (to, from, next) {
        this.curPanel = (to.query.panel * 1 === 1) ? 'service' : 'project'
        next()
    },
    computed: {
        isExportShow () {
            return (this.subproject.length !== 0)
        },
        ...mapState({
            currentPage: 'curServicePage',
            condition: 'formFilter'
        })
    },
    mounted () {
        this.getInfo(this.$route.query.id)
        this.$router.replace({
            query: merge(this.$route.query, { 'panel': 0 })
        })
    },
    methods: {
        changeTab (e) {
            let search = (e.name === 'service') ? 1 : 0
            this.curPanel = e.name
            this.$router.replace({
                query: merge(this.$route.query, { 'panel': search })
            })
        },
        deleteServiceWork (id) {
            this.$confirm(`项目成果删除操作不可逆, 请确认是否继续操作?`, '删除项目成果记录提醒', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.post('/api/user/project/delprojectwork', qs.stringify({
                    id
                }))
                    .then((res) => {
                        if (res.code === 0) {
                            this.$notify.success({
                                title: '通知',
                                message: `项目成果记录删除成功。`
                            })
                            this.getInfo(this.$route.query.id)
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.log(err)
                        // this.$Message.error('网络错误，请稍候再试。');
                    })
            })
        },
        showPhotoViewer (src) {
            this.photoViewer.status = true
            this.photoViewer.path = src
        },
        checkboxInit (row, index) {
            return (row.status === 0 || row.status === 9)
        },
        toPreview (src) {
            let ext = this.getExt(src)
            let pathComponent = encodeURIComponent(src)
            if (['doc', 'docx', 'xls', 'xlsx'].includes(ext)) {
                window.open(`https://view.officeapps.live.com/op/view.aspx?src=${pathComponent}`)
            } else if (['pdf'].includes(ext)) {
                let routeData = this.$router.resolve({
                    path: '/view',
                    query: {
                        path: pathComponent
                    }
                })
                window.open(routeData.href, '_blank')
            } else if (['jpg', 'png', 'gif', 'bmp', 'jpeg', 'webp'].includes(ext)) {
                this.showPhotoViewer(src)
            } else {
                window.open(src)
            }
        },
        getExt (src) {
            // eslint-disable-next-line node/no-deprecated-api
            let path = URL.parse(src).pathname
            return path.substring(path.lastIndexOf('.') + 1)
        },
        batchConfirm () {
            let subIds = this.$refs.serviceTable.selection.map(item => item.sub_id)
            if (subIds.length === 0) {
                return
            }
            this.$http.post('/api/user/project/batchconfirm', qs.stringify({
                id: this.info.id,
                sub_ids: JSON.stringify(subIds)
            }))
                .then((res) => {
                    if (res.code === 0) {
                        this.getSubList(this.info.id)
                        this.$notify.success({
                            title: '通知',
                            message: `批量确认人员操作成功。`
                        })
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.log(err)
                    // this.$Message.error('网络错误，请稍候再试。');
                })
        },
        batchSettlement () {
            let subIds = this.$refs.serviceTable.selection.map(item => item.sub_id)
            if (subIds.length === 0) {
                return
            }
            this.$http.post('/api/user/project/batchsettlement', qs.stringify({
                id: this.info.id,
                sub_ids: JSON.stringify(subIds)
            }))
                .then((res) => {
                    if (res.code === 0) {
                        this.getSubList(this.info.id)
                        this.$notify.success({
                            title: '通知',
                            message: `批量确认结算操作成功。`
                        })
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.log(err)
                    // this.$Message.error('网络错误，请稍候再试。');
                })
        },
        downloadQD () {
            this.download(`${process.env.VUE_APP_BASE}/api/user/downservicelist?project_id=${this.$route.query.id}`)
        },
        downloadFBD () {
            this.download(`${process.env.VUE_APP_BASE}/api/user/downreleaselist?project_id=${this.$route.query.id}`)
        },
        selectionChange (selection) {
            this.isIndeterminate = selection.length > 0 && selection.length < this.subproject.length
            this.isCheckAll = !(selection.length === 0)
        },
        serviceTableSelectChange (e) {
            this.$refs.serviceTable.toggleAllSelection(e)
        },
        toDetail (e) {
            router.push(`/index/project/serviceinfo?id=${this.$route.query.id}&sub_id=${e}`)
        },
        onPageChange (e) {
            this.$store.commit('changeServicePage', e)
            this.getSubList(this.$route.query.id, e)
        },
        onFilter () {
            this.currentPage = 1
            this.getSubList(this.$route.query.id, 1)
            this.form = this.formFilter
        },
        onExport () {
            this.download(`${process.env.VUE_APP_BASE}/api/user/downloadsublists?id=${this.info.id}&name=${this.form.name}&idcard=${this.form.idcard}&status=${this.form.status}`, '服务列表.xls')
        },
        download (url, fileName = '') {
            let eleLink = document.createElement('a')
            let authorization = localStorage.getItem('token')
            eleLink.download = fileName
            eleLink.style.display = 'none'
            eleLink.href = url + '&authorization=' + authorization
            document.body.appendChild(eleLink)
            eleLink.click()
            document.body.removeChild(eleLink)
        },
        fileDownload (url, fileName = '') {
            const eleLink = document.createElement('a')
            const authorization = localStorage.getItem('token')
            eleLink.download = fileName
            eleLink.style.display = 'none'
            eleLink.href = `${process.env.VUE_APP_BASE}/api/user/filedownload?path=${url}&filename=${fileName}&authorization=${authorization}`
            document.body.appendChild(eleLink)
            eleLink.click()
            document.body.removeChild(eleLink)
        },
        filterByFakeStatus (status) {
            this.formFilter.fake_status = status
            this.curPanel = 'service'
            this.form = Object.assign({}, this.formFilter)
            this.getSubList(this.$route.query.id, 1)
        },
        getSubList (id, page = this.currentPage) {
            this.$http.get('/api/user/project/sublists', {
                params: {
                    id,
                    page,
                    size: 10,
                    status: this.formFilter.status,
                    name: this.formFilter.name,
                    idcard: this.formFilter.idcard,
                    fake_status: this.formFilter.fake_status
                }
            })
                .then((res) => {
                    if (res.code === 0) {
                        this.subproject = res.data.listData
                        this.total_page = res.data.total_page
                    } else {
                        this.$message.error(res.message)
                    }
                })
                .catch(err => {
                    console.log(err)
                    // this.$Message.error('网络错误，请稍候再试。');
                })
        },
        getInfo (id) {
            this.$http.get('/api/user/project/info', {
                params: {
                    id
                }
            })
                .then(res => {
                    if (res.code === 0) {
                        this.info = res.data
                        if (![0, 7].includes(res.data.status)) {
                            this.getSubList(this.$route.query.id)
                        }
                    } else {
                        this.$message.warning(res.message)
                    }
                })
                .catch(err => {
                    console.error(err)
                })
        },
        changeServiceStatus (sub_id, handle) {
            this.$confirm(`此操作将${handle * 1 === 1 ? '确认' : '拒绝'}服务用户, 是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.get('/api/user/project/subconfirm', {
                    params: {
                        id: this.$route.query.id,
                        sub_id,
                        status: handle
                    }
                })
                    .then((res) => {
                        if (res.code === 0) {
                            this.$notify.success({
                                title: '通知',
                                message: `${handle * 1 === 1 ? '确认' : '拒绝'}服务用户操作成功。`
                            })
                            this.getSubList(this.$route.query.id)
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.log(err)
                        // this.$Message.error('网络错误，请稍候再试。');
                    })
            })
        },
        toggleRowExpansion (row) {
            if (row.id === this.expands[0]) {
                this.expands = []
            } else {
                this.expands = []
                this.expands.push(row.id)
            }
        },
        closePro (id) {
            this.$confirm(`此操作将关闭此项目, 是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.get('/api/user/project/close', {
                    params: {
                        id
                    }
                })
                    .then((res) => {
                        if (res.code === 0) {
                            this.$notify.success({
                                title: '通知',
                                message: `项目关闭成功。`
                            })
                            this.getInfo(id)
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.log(err)
                        // this.$Message.error('网络错误，请稍候再试。');
                    })
            })
        },
        messageNotify (sub_id, sign) {
            this.$confirm(`此操作将短信提醒用户操作, 是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$http.post('/api/user/project/subsendsms', qs.stringify({
                    id: this.$route.query.id,
                    sub_id,
                    type: sign
                }))
                    .then((res) => {
                        if (res.code === 0 && res.data && res.data.send_status === 1) {
                            this.$notify.success({
                                title: '通知',
                                message: `短信提醒操作成功。`
                            })
                        } else if (res.code === 0) {
                            this.$message.error((res.data && res.data.msg) || '发送短信失败')
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                    .catch(err => {
                        console.log(err)
                        // this.$Message.error('网络错误，请稍候再试。');
                    })
            })
        }
    }
}
</script>

<style scoped lang="scss">
    @import "../../assets/style/sub.scss";
    @import "../../assets/style/detail";

    .table {
        .box {
            display: flex;
            line-height: 1.5;

            .cell {
                flex: 1;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                &:last-child {
                    flex: 3;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }

                display: flex;

                .cell__label {
                    color: #999;
                    width: 70px;
                    .item__lable {
                        margin-right: 10px;
                    }
                }

                .cell__value {
                    max-width: calc(100% - 70px);
                    flex: 1;
                    color: #666;
                    padding-left: 8px;
                }
            }
        }
    }

    .area-title {
        line-height: 20px;
        &::before {
            top: 0;
        }
        &.flex {
            margin-right: 20px;
            display: flex;
            margin-bottom: 10px;
            justify-content: space-between;
            align-items: center;
            &::before {
                top: 5px;
            }
            &.fix {
                &::before {
                    top: 0;
                }
            }
        }
    }

    .service-work__wrapper {
        border-top: 1px solid $--border-color-base;
        color: #666666;
        margin: 15px -24px 0;
        padding: 0 24px;

        .service-work {
            padding: 20px;
            border-bottom: 1px solid $--border-color-base;

            &:last-child {
                border-bottom-width: 0;
            }
            .abstract {
                display: flex;
                justify-content: space-between;
                margin-bottom: 16px;
            }
            .content-wrapper {
                display: flex;
                align-items: center;

                .main {
                    flex: 1;
                }
            }

            .content {
                line-height: 1.5;
            }

            .pics {
                margin-top: 16px;
                .pic-item {
                    display: inline-flex;
                    width: 210px;
                    justify-content: space-between;
                    border: 1px solid #ededed;
                    border-radius: 4px;
                    align-items: center;
                    margin-right: 40px;
                    margin-bottom: 14px;
                    padding: 10px 14px;
                    cursor: pointer;
                    span {
                        color: $--color-primary;
                        &:hover {
                            text-decoration: underline;
                        }
                    }
                }

                .download-btn {
                    cursor: pointer;
                    display: inline-block;
                    width: 140px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }

            &:last-child {
                border-bottom-width: 0;
            }
        }
    }
    .text-underline {
        text-decoration: underline;
    }
</style>
